/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M7 5h6a3.5 3.5 0 0 1 0 7h-6z", "key": "svg-0" }], ["path", { "d": "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7", "key": "svg-1" }]];
const IconBold = createReactComponent("outline", "bold", "Bold", __iconNode);

export { __iconNode, IconBold as default };
//# sourceMappingURL=IconBold.mjs.map
